import React, { useState } from 'react';

import {
  Box,
  Container,
  Typography,
  makeStyles,
  Button,
  colors
} from '@material-ui/core';
import Page from 'src/components/Page';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  image: {
    marginTop: 50,
    marginBottom: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560,
    padding: 50
  }
}));

const NotFoundView = () => {

  const classes = useStyles();

  const [profile, setProfile] = useState(localStorage.getItem('profile'));

  return (
    <Page
      className={classes.root}
      title="404"
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="md">
          <Typography
            align="center"
            style={{ color: colors.red[600] }}
            variant="h1"
          >
            <b>Erro 404:</b>
          </Typography>
          <Typography
            align="center"
            color="textPrimary"
            variant="h2"
          >
            Acesso inválido de um recurso da aplicação
          </Typography>
          <Typography
            align="center"
            color="textPrimary"
            variant="h5"
          >
            Página não foi encontrada no Sistema Integrado de Manutenção e Monitoramento
          </Typography>

          <Box textAlign="center">
            <img
              alt="Under development"
              className={classes.image}
              src="/static/error.svg"
            />
          </Box>
          <Box textAlign="center">
            <Button
              color="secondary"
              component="a"
              href={(profile == 'AST') ? '/sup/main' : (profile == 'ENG') ? '/cfg/main' : (profile == 'ADM') ? '/adm/main' : (profile == 'AAD') ? '/mgt/main' : '/mon/main'}
              variant="contained"
            >
              Voltar
            </Button>
          </Box>
        </Container>
      </Box>
    </Page >
  );
};

export default NotFoundView;
